import React from 'react';
import { Box, Grid } from '@mui/material';
import { SimButton } from 'components/SimButton';
import SimSectionTitle from 'components/SimSectionTitle';
import { SimChildJourney } from 'components/SimChildJourney';
import RightArrowIcon from 'components/icons/RightArrowIcon';

const Services = () => {
	return (
		<Box>
			<SimSectionTitle
				title="Your Child's Journey with us"
				subtitle="We empower your child's development at all stages"
			/>

			<Grid container spacing={2}>
				<SimChildJourney />
			</Grid>
			<Box marginTop={4} display={'flex'} justifyContent={'center'}>
				<SimButton
					color={'primary'}
					variant={'contained'}
					href={'/contact'}
					size={'large'}
					endIcon={<RightArrowIcon />}>
					Ready to Join Us?
				</SimButton>
			</Box>
		</Box>
	);
};

export { Services };
